import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormRow } from '@dropbox/dig-components/form_row';
import { Checkbox } from '@dropbox/dig-components/controls';
import { Text } from '@dropbox/dig-components/typography';
import { useSiteCode } from 'js/sign-components/common/use-site-code';
import { getBrandName } from 'js/sign-components/common/brand';
import {
  AuthState,
  UpdateType,
} from 'signer-app/authentication/use-authentication';
import styles from './authentication.module.scss';

export type MarketingOptProps = {
  marketingMode: string;
  state: AuthState;
  update: UpdateType;
};

function MarketingOpt({ marketingMode, state, update }: MarketingOptProps) {
  const siteCode = useSiteCode();
  const brandName = getBrandName(siteCode);

  if (marketingMode === 'none') {
    return <div data-testid="marketing-opt"></div>;
  }

  return (
    <FormRow>
      <div className={styles.checkboxGroup} data-testid="marketing-opt">
        <Checkbox
          id="marketing-checkbox"
          data-testid="marketing-checkbox"
          disabled={state.isLoading}
          onChange={() => update('marketingOpt', !state.marketingOpt)}
          checked={state.marketingOpt}
        />
        <Text
          tagName="label"
          htmlFor="marketing-checkbox"
          data-testid={marketingMode}
        >
          {marketingMode === 'opt-in' && (
            <FormattedMessage
              id=""
              defaultMessage="I would like to receive marketing email updates from {brandName}"
              description="checkbox, asks user if user agrees to receive marketing/updates emails"
              values={{
                brandName,
              }}
            />
          )}
          {marketingMode === 'opt-out' && (
            <FormattedMessage
              id=""
              description="Label for the opt-out marketing checkbox"
              defaultMessage="I don't want to receive marketing email updates from {brandName}"
              values={{
                brandName,
              }}
            />
          )}
        </Text>
      </div>
    </FormRow>
  );
}

export default MarketingOpt;
